<template>
    <div class="sidebar-item position-relative" :class="{'no-items': !this.activeItems.length > 0}">
        <transition name="vue-table-loader">
            <div class="vue-table-loader" v-if="uiStates.showLoading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
        </transition>
        <transition name="fade" mode="out-in">
            <div key=1 v-if="uiStates.showSelect" class="sidebar-selector sidebar-selector-value-group clearfix">
                <div class="select-container">
                    <select2 v-model="selectedItem" :name="'value_group_'+groupingNameForLoad" class="attribute_select" :config="{placeholder: '', width: '100%'}">
                        <option>Please Choose...</option>
                        <option v-for="selectableItem in selectableItems" :value="selectableItem.id">{{selectableItem.name}}</option>
                    </select2>
                </div>
                <button v-if="selectedItem != null && selectedItem != 'Please Choose...'" type="button" v-on:click.prevent="addItem()" class="btn btn-primary">Done</button>
                <button v-else type="button" v-on:click.prevent="uiStates.showSelect = false" class="btn btn-danger">Cancel</button>
            </div>
            <div key=2 v-else class="sidebar-item-heading" :class="{'no-border' : Object.keys(activeItems).length === 0}">
                <span class="title">{{this.groupingName}}</span>
                <a v-if="multiple" href="#" v-on:click.prevent="getListing()" class="action-trigger">Add More</a>
                <a v-else class="action-trigger" v-bind:class="{'text-muted defaultcursor': (groupingNameForLoad == 'option_set' && $parent.$parent.hasChildren)}" href="#" v-on:click.prevent="getListing()">Change</a>
            </div>
        </transition>
        <div class="sidebar-item-body" v-if="Object.keys(activeItems).length !== 0">
            <div v-for="activeItem in activeItems" class="option-item">
                <template v-if="groupingNameForLoad == 'categories'">
                    <a v-if="activeItem.is_smart === 0" @click="launchOptionsModal(activeItem, groupingName)" href="#" class="action-trigger"><i class="fa fa-minus-circle" aria-hidden="true"></i></a>
                </template>
                <template v-else>
                    <a v-if="requireDeleteConfirmation == 'true'" @click="launchOptionsModal(activeItem, groupingName)" href="#" class="action-trigger"><i class="fa fa-minus-circle" aria-hidden="true"></i></a>
                    <span v-else-if="groupingNameForLoad == 'option_set' && $parent.$parent.hasChildren" class="action-trigger-disabled"><i class="fa fa-window-minimize fa-"></i></span>
                    <a v-else v-on:click.prevent="deleteItem(activeItem)" href="#" class="action-trigger"><i class="fa fa-minus-circle" aria-hidden="true"></i></a>
                </template>
                <span class="copy"><span v-if="groupingNameForLoad == 'categories'" class="info-marker"><i class="fas fa-info-circle"></i></span> {{activeItem.name}}</span>
                <div v-if="groupingNameForLoad == 'categories'" class="product-preview">
                    <div class="product-preview-heading">
                        <div class="copy">
                            <div class="title">{{activeItem.name}}</div>
                            <div class="sku"><strong>Full Category Tree:</strong> <br>{{activeItem.fqn_cache}}</div>
                            <div  v-if="activeItem.desc != null" class="sku mt-1"><strong>Description:</strong> <br>
                                <div class="cat-desc" v-html="activeItem.desc"></div>
                            </div>
                        </div>
                        <a class="link-to-product" :href="'/categories/'+activeItem.id+'/edit'"><i class="fa fa-external-link" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>

            <transition name="vue-table-loader">
                <div class="messaging" v-if="message">{{message}}</div>
            </transition>
        </div>
        <!-- Modal -->
        <div class="modal fade modern" :id="'confirmDelete-'+convertToKebabCase(groupingName)" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Are you sure?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modal.confirmation = ''">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>{{confirmationMessage}}</p>
                    </div>
                    <div class="modal-footer">
                        <div class="form-group footer-form-group">
                            <label class="text-left w-100" for="">Type <strong>"DELETE"</strong> to confirm</label>
                            <input type="text" class="form-control" :id="groupingName + 'delete'" aria-describedby="helpId" placeholder="" v-model="modal.confirmation">
                        </div>
                        <button @click="modal.confirmation = ''" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button :disabled="modal.confirmation != 'DELETE'" class="btn btn-danger" data-dismiss="modal" v-on:click.prevent="deleteOption()">Delete</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import select2 from 'select2';

    Vue.use(VueEvents)

    export default {
        name: 'product-value-group',
        props: ['groupingRoute','groupingGetRoute', 'groupingItemsRoute', 'groupingName', 'productDetails', 'allowMultiple', 'groupingNameForLoad', 'requireDeleteConfirmation', 'confirmationMessage'],
        components:{
        },
        data() {
            return {
                modal : {
                    confirmation: ""
                },
                uiStates: {
                    showSelect: false,
                    showLoading: false,
                },
                message: "",
                activeItems: {},
                multiple: this.allowMultiple,
                selectableItems: {},
                selectedItem: null,
                activeItem: null
            }
        },
        mounted() {
            this.getActiveItems();
            this.$forceUpdate()
        },
        created() {

        },
        watch: {
            message: function(query) {
                setTimeout(function() {
                    this.message = "";
                }.bind(this), 3000);
            },
        },
        methods: {
            deleteOption(){
                this.deleteItem(this.activeItem);
            },
            launchOptionsModal(activeItem, groupingName){
                $('#confirmDelete-'+this.convertToKebabCase(groupingName)).modal('show');
                this.activeItem = activeItem;
            },
            convertToKebabCase(str) {
                if (str == null) {
                    return;
                }
                return str.replace(/\s+/g, '-').toLowerCase();
            },
            getActiveItems: function () {
                this.uiStates.showLoading = true;
                axios.get(base_url + this.groupingItemsRoute, {
                    // 'criteria': criteria,
                })
                .then(function (response) {
                    this.activeItems = response.data.payload;
                    this.$parent.$parent.loadedStates[this.groupingNameForLoad] = true;
                    this.uiStates.showLoading = false;
                }.bind(this))
                .catch(function (error) {
                    this.message = 'An error has occured!';
                    this.uiStates.showLoading = false;
                }.bind(this));
            },
            getListing: function () {
                if (!this.$parent.$parent.permissionAllowed('manage_products')) {
                    this.message = 'Operation not allowed!';
                    this.uiStates.showLoading = false;
                    return;
                }
                if (this.groupingNameForLoad == 'option_set' && this.$parent.$parent.hasChildren) {
                    return;
                }
                this.uiStates.showLoading = true;
                if (Object.keys(this.selectableItems).length === 0) {
                    $('.sidebar-selector-value-group select').empty().select2('destroy');
                    axios.get(base_url + this.groupingGetRoute, {
                        // 'criteria': criteria,
                    })
                    .then(function (response) {
                        $('.sidebar-selector-value-group select').select2({ data : response.data, width: "100%", placeholder: {id: '-1', text: 'Please Choose'}});
                        this.selectableItems = response.data.payload;
                        this.uiStates.showSelect = true;
                        this.uiStates.showLoading = false;
                    }.bind(this))
                    .catch(function (error) {
                        this.uiStates.showLoading = false;
                        this.message = 'An error has occured!';
                    }.bind(this));
                }else{
                    this.uiStates.showSelect = true;
                    this.uiStates.showLoading = false;
                }
            },
            addItem: function () {
                if (!this.$parent.$parent.permissionAllowed('manage_products')) {
                    this.message = 'Operation not allowed!';
                    this.uiStates.showLoading = false;
                    return;
                }
                if (this.selectedItem != null && this.selectedItem != 'Please Choose...') {
                    axios.post(this.groupingRoute + this.selectedItem, {
                        // 'criteria': criteria,
                    })
                    .then(function (response) {
                        this.getActiveItems();
                        this.message = response.data.message;
                        if (this.groupingGetRoute === '/pimapi/attribute_sets' || this.groupingGetRoute === '/userinterface/attributes') {
                            this.$parent.$parent.loadedPanelData.attributes = null;
                            this.$parent.$parent.loadedPanelData.attributes = false;
                        }
                        if (this.groupingGetRoute === '/pimapi/option_sets') {
                            this.$parent.$parent.loadedPanelData.children = null;
                            this.$parent.$parent.loadedPanelData.children = false;
                        }
                        if (this.groupingName === "Option Set") {
                            window.location.reload(true);
                        }
                        this.uiStates.showSelect = false;
                        this.uiStates.showLoading = false;
                    }.bind(this))
                    .catch(function (error) {
                        this.message = 'An error has occured!';
                        this.uiStates.showLoading = false;
                    }.bind(this));
                } else {
                    this.uiStates.showSelect = false;
                    this.uiStates.showLoading = false;
                    this.message = 'nothing selected';
                }
            },
            deleteItem: function (activeItem) {
                if (!this.$parent.$parent.permissionAllowed('manage_products')) {
                    this.message = 'Operation not allowed!';
                    this.uiStates.showLoading = false;
                    return;
                }
                let targetId = activeItem.id;
                if (this.groupingName === "Attributes") {
                    targetId = activeItem.attribute_id;
                }
                 axios.delete(this.groupingRoute + targetId, {
                    // 'criteria': criteria,
                })
                .then(function (response) {
                    this.getActiveItems();
                    this.message = response.data.message;
                    if(this.groupingGetRoute === '/pimapi/attribute_sets' || this.groupingGetRoute === '/pimapi/attributes') {
                        this.$parent.$parent.loadedPanelData.attributes = null;
                        this.$parent.$parent.loadedPanelData.attributes = false;
                    }
                    if(this.groupingGetRoute === '/pimapi/option_sets') {
                        this.$parent.$parent.loadedPanelData.children = null;
                        this.$parent.$parent.loadedPanelData.children = false;
                    }

                    this.uiStates.showLoading = false;
                    if (this.groupingName === "Option Set") {
                        window.location.reload(true);
                    }
                }.bind(this))
                .catch(function (error) {
                    this.message = 'An error has occured!';
                    this.uiStates.showLoading = false;
                }.bind(this));
            },
        }
    };
</script>

<style scoped lang="scss">
.btn:not(.btn-primary, .btn-secondary){
    padding:10px 0 !important;
}
.sidebar-item.no-items{
    height: 40px;
}
    .vue-table-loader{
        background-color: #fff;
        text-align: right;
        padding-top: 0px;
        padding-right: 4px;
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }
    .sidebar-item-heading{
        height: 41px;
    }
    .messaging{
        color: #566670;
        position: absolute;
        bottom: 5px;
        right: 5px;
        font-size: 8px;
    }

    .modal-body {
        p{
            color: #AB5755;
            font-size: 14px;
        }
    }
    .modal-title {
        font-size: 16px;
    }
    .modal-footer {
        label {
            font-size: 11px;
        }
        border-top: 0;
        padding-top: 0;
    }

    .footer-form-group{
        width: 100%;
    }

    .action-trigger-disabled {
        font-size: 5px;
        color: #383d44;
        position: relative;
        top: -2px;
    }
    .option-item{
        position: relative;
        .product-preview{
            transition: opacity linear 0.3s, z-index linear 0.3s;
            z-index: -1;
            opacity: 0;
            position: absolute;
            bottom: 13px;
            left: -319px;
            .title{
                border-bottom: 1px solid #dedede;
                padding-bottom: 10px;
                margin-bottom: 10px;
            }
            .product-preview-heading .link-to-product{
                top: 15px;
                right: 15px;
            }
        }
        &:hover{
            .product-preview{
                transition: opacity linear 0.3s, z-index linear 0.3s;
                opacity: 1;
                z-index: 1000;
            }
        }
    }
    .info-marker{
        font-size: 12px;
        top: 1px;
        position: relative;
        margin-right: 4px;
        color:#bfbfbf;
    }
    .cat-desc{
        max-height: 100px;
        overflow-y: auto;
        &::-webkit-scrollbar {
            width: 4px;
        }
        &::-webkit-scrollbar-track {
            background: rgba(0,0,0,0);
            position: absolute;
            top: 0px;
            bottom: 0px;
            right: 0px;
        }
        &::-webkit-scrollbar-thumb {
            background: #25628F;
            border-radius:2px;
        }
        &::-webkit-scrollbar-thumb:hover {
            background: #25628F;
        }
    }
</style>
